import React, { createContext, useContext, useState, useEffect } from 'react';
import { loginWithGoogle, getMe, logout as apiLogout } from '../api/auth';
import { getRefreshToken } from '../api/client';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = async () => {
    const me = await getMe();
    setUser(me);
    return me;
  };

  useEffect(() => {
    const restore = async () => {
      const refresh = getRefreshToken();
      if (!refresh) { setLoading(false); return; }
      try {
        await refreshUser();
      } catch {
      } finally {
        setLoading(false);
      }
    };
    restore();
  }, []);

  const login = async (credential) => {
    const userData = await loginWithGoogle(credential);
    setUser(userData);
    return userData;
  };

  const logout = () => {
    apiLogout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
